module.exports = __webpack_public_path__ + "img/01.aae43ffc.jpg";